import { render, staticRenderFns } from "./documents-detail.vue?vue&type=template&id=00932d46&"
import script from "./documents-detail.vue?vue&type=script&lang=js&"
export * from "./documents-detail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports